







import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'NoteIndicator',
})
export default class NoteIndicator extends Vue {
  @Prop({ type: Boolean, default: false })
  hasNotes!: boolean;

  @Prop({ type: Number, default: 0 })
  noteCount!: number;

  @Prop({ type: Boolean, default: false })
  showCount!: boolean;

  @Prop({ type: String, required: false })
  customTooltip?: string;

  get tooltipText(): string {
    if (this.customTooltip) {
      return this.customTooltip;
    }

    if (this.noteCount > 1) {
      return this.$t('noteIndicator.hasNotes', { count: this.noteCount }) as string;
    } else if (this.noteCount === 1) {
      return this.$t('noteIndicator.hasOneNote') as string;
    } else {
      return this.$t('noteIndicator.hasNotesGeneric') as string;
    }
  }
}
